import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateClass = async (e, uid, SchoolId) => {
  try {
    const ClassesCollection = await collection(db, "Classes");

    const data = HelperForMetaData({
      ...e,
      SchoolID: SchoolId,
    });
    await addDoc(ClassesCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateClass;
